/**
 * Compatibility shim — the real topbar (search + notifications + user menu)
 * is now rendered by shell/TopBar.js via DashboardShell. Legacy pages still
 * import DashboardNavbar, but it renders nothing here.
 */

export default function DashboardNavbar() {
  return null;
}
